module.exports = __webpack_public_path__ + "static/media/close.7082e21a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AcceptanceConditionsModal/close.svg
// module id = 289
// module chunks = 0